export type ModeloBalanca = 'urano' | 'elgin';

export interface ConfiguracaoBalanca {
  modelo: ModeloBalanca;
  baudRate: number;
  dataBits: number;
  stopBits: number;
  parity: 'none' | 'even' | 'odd';
}

export function configuracaoPadraoBalanca(modelo: ModeloBalanca): ConfiguracaoBalanca {
  return {modelo, baudRate: 9600, dataBits: 8, stopBits: PERFIS_BALANCA[modelo].stopBits, parity: 'none'};
}

export function configuracaoBalancaValida(config: any): config is ConfiguracaoBalanca {
  return !!config && (config.modelo === 'urano' || config.modelo === 'elgin')
    && [2400, 4800, 9600, 19200].includes(config.baudRate)
    && [7, 8].includes(config.dataBits) && [1, 2].includes(config.stopBits)
    && ['none', 'even', 'odd'].includes(config.parity);
}

// requisicao: bytes que o computador envia para pedir o peso.
// Urano (documento "Protocolo Serial US POP Light / POP-S / POP-Z"): 0x04 seguido de 0x05.
// Elgin DP30-T (Prt3/Toledo): ENQ 0x05.
export const PERFIS_BALANCA = {
  urano: {nome: 'Urano US 31/2 POP-S', configuracao: 'PROT 3', stopBits: 2, capacidadeKg: 31, requisicao: [0x04, 0x05]},
  elgin: {nome: 'Elgin DP30-T', configuracao: 'Serial 1010 (Demanda peso 1, 9600, N81)', stopBits: 1, capacidadeKg: 30, requisicao: [0x05]}
};

// Urano POP-S PROT 3 e Elgin DP30-T Demanda peso 1: STX + cinco caracteres + ETX. Peso em gramas.
export class ProtocoloBalanca {
  private quadro: number[] = [];

  receba(bytes: Uint8Array): string[] {
    const respostas: string[] = [];
    for (const byte of bytes) {
      if (byte === 2) {
        this.quadro = [byte];
      } else if (this.quadro.length) {
        this.quadro.push(byte);
        if (byte === 3) {
          if (this.quadro.length === 7) {
            respostas.push(String.fromCharCode(...this.quadro.slice(1, 6)));
          }
          this.quadro = [];
        } else if (this.quadro.length >= 7) {
          this.quadro = [];
        }
      }
    }
    return respostas;
  }
}

// A balança respondeu corretamente, mas o peso não pode ser usado na operação.
export class ErroPesagemBalanca extends Error {
  constructor(public readonly status: string, mensagem: string) { super(mensagem); }
}

export function pesoBalancaEmKg(resposta: string, modelo: ModeloBalanca = 'urano', permitirZero = false): number {
  const perfil = PERFIS_BALANCA[modelo];
  if (resposta === 'NNNNN') throw new ErroPesagemBalanca('Peso negativo', 'Peso negativo. Confira o prato e a tara da balança.');
  if (resposta === 'IIIII') throw new ErroPesagemBalanca('Peso instável', 'Peso instável. Aguarde estabilizar e leia novamente.');
  if (resposta === 'SSSSS') throw new ErroPesagemBalanca('Sobrecarga', 'Balança em sobrecarga. Retire o excesso de peso.');
  if (!/^\d{5}$/.test(resposta)) throw new Error('Resposta inválida. Configure a balança em ' + perfil.configuracao + '.');
  const peso = Number(resposta) / 1000;
  if (!permitirZero && peso === 0) throw new ErroPesagemBalanca('Balança zerada', 'Coloque um item na balança e leia novamente.');
  if (peso > perfil.capacidadeKg) throw new ErroPesagemBalanca('Peso acima do limite', 'Retire o excesso de peso. O limite deste modelo é ' + perfil.capacidadeKg + ' kg.');
  return peso;
}
